
  import { defineComponent } from 'vue';

  export default defineComponent({
    name: 'ArrowDynamic',
    components: {},
    props: {
      value: {
        type: Number,
        required: true,
      },
    },
    data(): {} {
      return {};
    },
    computed: {
      getTextColor() {
        if (this.value === 0) return 'text-gray';
        return this.value > 0 ? 'text-green' : 'text-red';
      },
      getArrowIcon() {
        if (this.value === 0) return 'fa-equals';
        return this.value > 0 ? 'fa-arrow-up' : 'fa-arrow-down';
      },
    },
  });
